import React from "react";

const AlphaOne = () => {
    return (
        <div>
            <h1>Alpha One</h1>
            <p>Welcome to the Alpha One page.</p>
        </div>
    );
};

export default AlphaOne;